import { cn } from '@wayste/shadcn/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
    return (
        <div
            data-slot="skeleton"
            aria-hidden="true"
            className={cn('bg-surface-secondary animate-pulse rounded-md', className)}
            {...props}
        />
    );
}

export { Skeleton };
